import { Input } from "@synthesis/shared-ui";
import { useWatch } from "react-hook-form";

import { SIGNER_TYPE_OPTIONS } from "../../create-application-page.lib";
import { ApplicantRadioGroup } from "./create-application-applicant-form-controls";
import { CreateApplicationFormField, CreateApplicationFormRow, CreateApplicationFormSection } from "../create-application-form-layout";

export const ApplicantSignerSection = () => {
  const signerType = useWatch({ name: "signerType" });
  const isRepresentative = signerType === "representative";

  return (
    <CreateApplicationFormSection title="Сведения о подписанте" required>
      <CreateApplicationFormField label="Тип подписанта" required>
        <ApplicantRadioGroup name="signerType" options={SIGNER_TYPE_OPTIONS} horizontal />
      </CreateApplicationFormField>

      <CreateApplicationFormRow>
        <CreateApplicationFormField label="ФИО подписанта" required>
          <Input name="signerFullName" placeholder="Иванов Иван Иванович" />
        </CreateApplicationFormField>
        {isRepresentative ? (
          <CreateApplicationFormField label="Должность подписанта" required>
            <Input name="signerPosition" placeholder="Укажите должность подписанта" />
          </CreateApplicationFormField>
        ) : (
          <CreateApplicationFormField label="Основание полномочий" required>
            <Input name="signerAuthority" placeholder="Например: устав, доверенность, приказ, ОГРНИП" />
          </CreateApplicationFormField>
        )}
      </CreateApplicationFormRow>

      {isRepresentative && (
        <CreateApplicationFormRow>
          <CreateApplicationFormField label="Основание полномочий" required>
            <Input name="signerAuthority" placeholder="Например: устав, доверенность, приказ" />
          </CreateApplicationFormField>
          <CreateApplicationFormField label="Реквизиты основания" required>
            <Input name="signerAuthorityDetails" placeholder="Например: №12 от 15.03.2026" />
          </CreateApplicationFormField>
        </CreateApplicationFormRow>
      )}
    </CreateApplicationFormSection>
  );
};
